import React, { useState, memo, useCallback } from "react";
import { Button, CircularProgress } from "@mui/material";
import moment from "moment-jalaali";
import Api from "../../../utils/api";
import ExcelJS from "exceljs";

const TotalReward = ({ object, period_id }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await new Api().get(`/period/${period_id}/export`, object);
            if (response?.data?.length) {

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("reward");

                worksheet.columns = [
                    { header: "شناسه کاربر", key: "id", width: 13 },
                    { header: "نام", key: "full_name", width: 30 },
                    { header: "کد بازاریابی", key: "marketer_code", width: 22 },
                    { header: "موبایل", key: "mobile", width: 17 },
                    { header: "شبا", key: "shaba", width: 36 },
                    { header: "خرده فروشی", key: "total_retail", width: 13 },
                    { header: "پاداش معرفان", key: "total_reagent", width: 13 },
                    { header: "پورسانت از پورسانت", key: "total_reward_as_reward", width: 22 },
                    { header: "بن غیرنقدی کالا", key: "voucher", width: 13 },
                    { header: "پرداختی کل", key: "total_pay", width: 13 },
                    { header: "خرید ماهانه", key: "maintain", width: 13 },
                ];

                worksheet.getRow(1).eachCell(cell => {
                    cell.font = { size: 15, bold: true };
                    cell.alignment = { horizontal: "center", vertical: "center" };
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCEEFF" } };
                });

                response.data.forEach(item => {
                    const rowValues = {
                        id: item.id,
                        full_name: item.full_name,
                        marketer_code: item.marketer_code || '-',
                        mobile: item.mobile || '-',
                        shaba: item.shaba !== '-' ? 'IR' + item.shaba : '',
                        total_retail: parseInt(item.total_retail),
                        total_reagent: parseInt(item.total_reagent),
                        total_reward_as_reward: parseInt(item.total_reward_as_reward),
                        voucher: parseInt(item.voucher),
                        total_pay: parseInt(item.total_pay),
                        maintain: item.maintain,
                    };
                    const row = worksheet.addRow(rowValues);
                    row.eachCell(cell => {
                        cell.font = { size: 13, bold: false };
                        cell.alignment = { horizontal: "center", vertical: "center" };
                    });
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `reward_${period_id}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("خطا در صادرسازی فایل اکسل:", error);
        } finally {
            setLoading(false);
        }
    }, [object, period_id]);

    return (
        <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={fetchData}
            disabled={loading}
        >
            {loading ? <CircularProgress size={16} /> : "خروجی کلی"}
        </Button>
    );
};

export default memo(TotalReward);
